import type {RecommendedTemplatesData} from '@/ai-chat/ai-chat.types';

export const getRecommendedDesignTemplates = async (searchTags: string[]): Promise<RecommendedTemplatesData> => {
  return (await window.PMW.readLocal('ai/getRecommendedDesignTemplates', {
    searchTags,
  })) as RecommendedTemplatesData;
};

export const getIsTemplateRedesignFeatureEnabled = async (): Promise<boolean> => {
  try {
    return Boolean(await window.PMW.readLocal('ai/isTemplateRedesignFeatureEnabled'));
  } catch (error) {
    console.error(error);
    return false;
  }
};
